if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    $('[data-fancybox]').fancybox({
        toolbar: false,
        infobar: false,
        smallBtn : true,
        loop: true,
        mobile:{
            clickSlide: "close"
        }
    });

    $( ".form-module-wrapper p, .form-module-wrapper form").wrapAll( "<div class='form-module-wrapper__container animate-fade top'></div>" );

    $(window).bind('load scroll', function(){
        var valScroll = $(window).scrollTop();
        if($('.line-box').length > 0){
            $('.line-box').each(function(){
                var thisTop = $(this).offset().top;
                if(valScroll > thisTop-500){
                    $(this).addClass('visible');
                }
            })
        }
        if($('.line-box-green').length>0){
            $('.line-box-green').each(function(){
                var thisTop = $(this).offset().top;
                if(valScroll > thisTop-500){
                    $(this).addClass('visible');
                }
            })
        }
        if($('.line-box-room').length>0){
            $('.line-box-room').each(function(){
                var thisTop = $(this).offset().top;
                if(valScroll > thisTop-500){
                    $(this).addClass('visible');
                }
            })
        }
        
    });


    $('#open-terms').click(function(){
        $('#terms-conditions').toggle('slow');
        if($(this).hasClass('active')){
            $(this).removeClass('active');
        }else{
            $(this).addClass('active');
        }
    });

    $('.form-accordion__form-module').hide();
    $('.form-accordion__open-form').click(function(){
        $('.form-accordion__form-module').fadeIn('slow');
    })
    $('.form-accordion__close-form').click(function(){
        $('.form-accordion__form-module').hide();
    })


    $('#id_4_741').on('change',function(){
        $('#id_5_741').val($(this).val());
    });

    
    $('#id_5_740').on('change',function(){
        let date = $('#id_5_740').datepicker('getDate');
        var newDate = new Date(date.setMonth(date.getMonth()+1));
        var newMonth = ( newDate.getMonth() + 1 ) < 10 ? "0" + ( newDate.getMonth() + 1 ) : newDate.getMonth() + 1
        var newDay = ( newDate.getDate()) < 10 ? "0" + ( newDate.getDate() ) : newDate.getDate()
        $('#id_6_740').val(newMonth + '/' +  newDay + '/' + newDate.getFullYear());
    });

    var data = document.URL
    if($('#form_id-740').length > 0){
        if(data.indexOf('?') != -1){
            $('.form-accordion__open-form').click();
            data = data.split("?")[1];
            setTimeout(function(){
                var top_col = $(data).offset().top;
                $('html,body').animate({scrollTop:top_col-500},1500);
            },1000)
        }        
    }


    if(document.querySelector('.dates #CheckIn') && document.querySelector('.dates #CheckOut')) {
        document.querySelector('.dates #CheckIn').setAttribute('aria-label', 'Enter Your Arrival Date');
        document.querySelector( '.dates #CheckOut' ).setAttribute('aria-label', 'Enter your departure date');
    }

    if( document.querySelector('#oakhurstinnrequestproposal-form .form-module__submit button[type="submit"]') ) {
        let button = document.querySelector('#oakhurstinnrequestproposal-form button[type="submit"]');
        button.setAttribute('aria-label', "submit request for proposal");
    }

    if( document.querySelector('#oakhurstinncontactinquiry-form .form-module__submit button[type="submit"]') ) {
        let button = document.querySelector('#oakhurstinncontactinquiry-form button[type="submit"]');
        button.setAttribute('aria-label', "submit form to contact our Inn");
    }

})();